<template>
  <div class="big_box">
    <p>2222</p>
  </div>
</template>

<script>
import navTars from "./navTars";
export default {
  name: "login2",
  components:{navTars},
  data(){
    return{
      navs:'活动查询',
    }
  },
  methods:{

  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/gkReport/Activity.vue